/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class CartDrawerRecommendations extends HTMLElement {
      constructor() {
      super();
      this.currentId = null;
    }

    connectedCallback() {
      // 1. Сразу пробуем загрузить, если ID уже есть
      this.checkAndLoad();

      // 2. Начинаем слежку за атрибутами элемента
      this.domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-id') {
            this.checkAndLoad();
          }
        });
      });

      this.domObserver.observe(this, { attributes: true });
    }

    disconnectedCallback() {
      if (this.domObserver) this.domObserver.disconnect();
    }

    checkAndLoad() {
      const newId = this.getAttribute('data-product-id');
      if (newId && newId !== this.currentId) {
        console.log('MutationObserver заметил смену ID на:', newId);
        this.loadRecommendations(newId);
      }
    }

    loadRecommendations(productId) {
      this.currentId = productId;
      const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;

      // Добавляем класс загрузки (можно сделать полупрозрачным в CSS)
      this.style.opacity = '0.5';

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('cart-drawer-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            this.innerHTML = recommendations.innerHTML;
            this.style.opacity = '1';
            this.classList.add('product-recommendations--loaded');
            
            // Ждем микросекунду для отрисовки DOM перед запуском Swiper
            setTimeout(() => this.initSwiper(), 10);
          }
        })
        .catch(e => console.error('Ошибка:', e));
    }

    initSwiper() {
      const swiperEl = this.querySelector('.swiper_cart-drawer-recommendations');
      if (swiperEl && typeof Swiper !== 'undefined') {
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
        
        new Swiper(swiperEl, {
          spaceBetween: 5,
          autoHeight: true,
          slidesPerView: 3.3,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next-rec'),
            prevEl: this.querySelector('.swiper-button-prev-rec'),
          },
        });
      }
      if (window.sliderProductCard) window.sliderProductCard();
    }
  }

  if (!customElements.get('cart-drawer-recommendations')) {
    customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
  }



  // document.addEventListener('DOMContentLoaded', function() {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   let hasActiveFilters = false;

  //   // 1. Проверяем, есть ли уже активные фильтры в URL
  //   for (const key of urlParams.keys()) {
  //     if (key.startsWith('filter.v.availability')) {
  //       hasActiveFilters = true;
  //       break;
  //     }
  //   }

  //   // 2. Если фильтров НЕТ (чистая страница или только UTM), активируем наличие
  //   if (!hasActiveFilters) {
  //     const filterForm = document.querySelector('[data-collection-filters-form]');
      
  //     if (filterForm) {
        
  //       // const event = new Event('input', { bubbles: false });
  //       // filterForm.dispatchEvent(event);

        
  //       urlParams.set('filter.v.availability', '1');
  //       window.location.search = urlParams.toString();
  //       /*
  //       */
  //     }
  //   }

  //   (function(history) {
  //     const targetParam = 'filter.v.availability'; // Имя вашего обязательного параметра
  //     const defaultValue = '1';      // Значение по умолчанию

  //     if ( ! document.body.classList.contains('template-collection')) return false;

  //     const wrap = (type) => {
  //         const original = history[type];
  //         return function() {
  //             let url = new URL(arguments[2] || window.location.href, window.location.origin);
              
  //             // Если параметра нет — принудительно добавляем
  //             if (!url.searchParams.has(targetParam)) {
  //                 url.searchParams.set(targetParam, defaultValue);
  //                 // Обновляем аргумент с URL для оригинального метода
  //                 if (arguments[2]) arguments[2] = url.pathname + url.search;
  //             }
              
  //             return original.apply(this, arguments);
  //         };
  //     };

  //     history.pushState = wrap('pushState');
  //     history.replaceState = wrap('replaceState');

      
  //   })(window.history);

    

  // });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
